import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../utility/getTemplateData';
import { Button } from '@paypalcorp/pp-react';
const messages = localsMessages('common/nextButton');

class NextButtonComponent extends React.Component {
  render() {
    const buttonnext = messages.button && messages.button.next;

    return (
      <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
        <Button
          className="btn-wide"
          id="payWithPP"
          disabled={this.props.disabled}
          onClick={this.props.handleNext}
        >
          {buttonnext}
        </Button>
      </div>
    );
  }
}

NextButtonComponent.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  handleNext: PropTypes.func,
};

export default NextButtonComponent;
